import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'serviceGroups' })
export class ServiceGroupsPipe implements PipeTransform {
  transform(arr: any[]): any[] {
    if (!arr || !Array.isArray(arr)) return [];
    return arr.map(item => ({
      label: item.name,
      items: (item.services || []).map((s: any) => ({ value: s, label: s.name }))
    }));
  }
}